import { Shift, ShiftsFieldSet } from '@rogoag/airtable/crm';
import { LocalAtRecord } from '../../../db';
import { crmBase } from '../../../airtable_crm';
import { alertError } from '../../../alertDispatcher';
import { createLocalAtRecordByAtModel } from '../../../db_ops/airtable_record_ops';

export function getCurrentShift(selectedShift: string, availableShifts: LocalAtRecord[]) {
  const [schedDate, robot, operatorName, rig] = selectedShift.split('/');

  const shiftObj = availableShifts.filter((shift) => {
    const shiftRobot = shift.get('Robot');
    const shiftOperator = shift.get('Operator Name');

    if (!shiftRobot || !shiftOperator) {
      return false;
    }

    return (
      shiftRobot[0] === robot &&
      shift.get('Sched Date') === schedDate &&
      shiftOperator[0] === operatorName &&
      shift.get('Rig #') === rig
    );
  });

  return shiftObj && shiftObj.length ? shiftObj[0] : undefined;
}

export async function getShiftRecordById(shiftId: string): Promise<LocalAtRecord<ShiftsFieldSet> | undefined> {
  // Look locally
  let shift = LocalAtRecord.getRecord<ShiftsFieldSet>('Shifts', shiftId);

  if (shift) {
    return shift;
  }

  // Try to fetch from AT
  try {
    const fetchedShiftRecord = await crmBase.shifts.get(shiftId, { returnAs: 'record' });

    if (!fetchedShiftRecord) {
      return undefined;
    }

    const record = LocalAtRecord.create<LocalAtRecord<ShiftsFieldSet>>();
    record.table = 'Shifts';
    record.id = shiftId;

    // @ts-ignore the fields have a type mismatch in this situation
    record.fields = fetchedShiftRecord.fields;
    shift = LocalAtRecord.getRecord<ShiftsFieldSet>('Shifts', shiftId);

    return shift;
  } catch (e) {
    console.error('getShiftRecordById - error', e);

    return undefined;
  }
}

export async function createShiftInAt(
  schedDate: string,
  robotId: string,
  operatorId: string,
  rigId: string,
): Promise<LocalAtRecord<ShiftsFieldSet> | void> {
  if (!schedDate || !robotId || !operatorId || !rigId) {
    alertError('Wrong parameters when creating a shift, aborting');

    return;
  }

  const newShift = new Shift({
    scheduledRobot: robotId,
    scheduleRig: [rigId],
    operator: operatorId,
    schedDate,
  });

  // Before refactor: Airtable.createRecord (which called .base.create and AirtableRecordClass.createRecord)
  await newShift.save();

  return createLocalAtRecordByAtModel(newShift);
}
